<script>

    import { toast } from 'bulma-toast'
    import { userStore, creditsStore, notifyStore, modalStore } from '../stores'

    import CreditsService from '../$services/credits.service.js'

    import Form from '../$components/form.svelte'
    import InputText from '../$components/input.text.svelte'
    import InputNumber from '../$components/input.number.svelte'

    import Button from '../$components/button.svelte'
    import ButtonSave from '../$components/button.save.svelte'
    
    let loading = false

    let data = {
        processor: 'admin',
        status: 'paid'
    }

    async function createCredit() {

        data.userId = $userStore._id

        loading = true
        const resp = await CreditsService.createCredit(data)
        loading = false

        if(!resp.success)
            return toast({message: resp.error.message, type: 'is-danger'})

        notifyStore.set('wallet_updated')
        creditsStore.append(resp.data)

        toast({message: 'Credito creado', type: 'is-success'})

        modalStore.close()
    }
</script>

<Form on:submit={ createCredit } { loading } >
    
    <div class="columns">
        <div class="column">
            <InputNumber bind:value={ data.amount } label="Monto" placeholder="Monto" min="-500000" max="0" />
        </div>
    </div>

    <div class="columns">
        <div class="column">
            <InputText bind:value={data.reference} label="Referencia" placeholder="Razón de descuento" />
        </div>
    </div>

    <div class="is-flex is-justify-content-flex-end is-align-items-center">
        <Button on:click={modalStore.close} text="Cancelar" icon="ban" />
        <ButtonSave />
    </div>
    
</Form>